class MiniCart extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));

        // Vérifiez si l'élément est présent après avoir défini le contenu
        this.getDeliveryDate(); // Appeler après avoir mis à jour le DOM
      })
      .catch(e => {
        console.error(e);
      });
  }


  open() {
    const detailsElement = this.drawer.querySelector('details');

    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState, openCartDrawer = true) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    (openCartDrawer) && this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
  getDeliveryDate() {
    const today = new Date();
    var currentTime = today.getHours();
    var fromDate = new Date();
    fromDate.setDate(today.getDate() + 2); // Utilisation de setDate pour ajouter des jours    
    if (today.is().monday()) {
        fromDate = fromDate.next().thursday();
      }
      if (today.is().tuesday()) {
        fromDate = fromDate.next().friday();
      }

      if (today.is().wednesday()) {
        fromDate = fromDate.next().saturday();
      }
      if (today.is().thursday()) {
        fromDate = fromDate.next().tuesday();
      }

      if (today.is().friday()) {
        fromDate = fromDate.next().wednesday();
      }

      if (today.is().saturday()) {
        fromDate = fromDate.next().wednesday();
      }

      if (today.is().sunday()) {
        fromDate = fromDate.next().wednesday();
      }

    let options = { weekday: 'long', month: 'long', day: 'numeric' };
    const text = this.querySelector('#fromDate');
    if (text) {
      text.innerHTML = fromDate.toLocaleString('fr-FR', options);
    } else {
      console.error('Element with id "fromDate" not found inside mini-cart.');
    }
  }


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
    
